/* OH! beauty - Subcategorias (Collection Tree): Shift+rueda y arrastre con raton sobre el carrusel existente (.ct-subcats-list). Sin librerias. */
(function () {
'use strict';
if (window.__ctSubcatsScroll) return;
window.__ctSubcatsScroll = true;

var SEL = '.ct-subcats-list';
var THRESHOLD = 6;
var drag = null;
var suppressClick = false;

function listFrom(t) {
if (!t) return null;
if (t.nodeType !== 1) t = t.parentElement;
return t && t.closest ? t.closest(SEL) : null;
}
function canScroll(el) {
return el.scrollWidth > el.clientWidth + 1;
}

/* Shift + rueda (respaldo para navegadores que no lo convierten a horizontal) */
document.addEventListener('wheel', function (e) {
if (!e.shiftKey || e.ctrlKey || e.metaKey) return;
var el = listFrom(e.target);
if (!el || !canScroll(el)) return;
if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
var unit = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? el.clientWidth : 1);
var d = e.deltaY * unit;
var max = el.scrollWidth - el.clientWidth;
if ((d < 0 && el.scrollLeft <= 0) || (d > 0 && el.scrollLeft >= max - 1)) return;
e.preventDefault();
el.scrollLeft += d;
}, { passive: false });

/* Arrastrar con el raton (solo raton; tactil y trackpad usan el scroll nativo) */
document.addEventListener('pointerdown', function (e) {
if (e.pointerType !== 'mouse' || e.button !== 0) return;
var el = listFrom(e.target);
if (!el || !canScroll(el)) return;
drag = { el: el, id: e.pointerId, x: e.clientX, left: el.scrollLeft, moved: false };
});

document.addEventListener('pointermove', function (e) {
if (!drag || e.pointerId !== drag.id) return;
var dx = e.clientX - drag.x;
if (!drag.moved) {
if (Math.abs(dx) < THRESHOLD) return;
drag.moved = true;
drag.el.classList.add('ct-is-dragging');
try { drag.el.setPointerCapture(e.pointerId); } catch (err) {}
var sel = window.getSelection && window.getSelection();
if (sel && sel.removeAllRanges) sel.removeAllRanges();
}
e.preventDefault();
drag.el.scrollLeft = drag.left - dx;
});

function endDrag(e) {
if (!drag || (e && e.pointerId !== drag.id)) return;
if (drag.moved) {
drag.el.classList.remove('ct-is-dragging');
suppressClick = true;
setTimeout(function () { suppressClick = false; }, 0);
}
drag = null;
}
document.addEventListener('pointerup', endDrag);
document.addEventListener('pointercancel', endDrag);
window.addEventListener('blur', function () { endDrag(); });

/* Un arrastre no debe abrir el enlace */
document.addEventListener('click', function (e) {
if (!suppressClick || !listFrom(e.target)) return;
e.preventDefault();
e.stopPropagation();
suppressClick = false;
}, true);

/* Evitar el arrastre nativo de imagenes y enlaces */
document.addEventListener('dragstart', function (e) {
if (listFrom(e.target)) e.preventDefault();
});
})();
